<div class="company-select">
<!--  <angular2-multiselect
    name="company"
    [data]="multiselectItems.company"
    [(ngModel)]="selectedCompanies"
    [settings]="multiselectSettings_Company"
    (onSelect)="manageCompanyChange()"
    (onDeSelect)="manageCompanyChange()"
    required>
  </angular2-multiselect>-->

  <ng-select class="custom"
             #select
             [placeholder]="multiselectSettings_Company.text"
             [items]="multiselectItems.company"
             bindLabel="itemName"
             bindValue="id"
             [clearable]="clearable"
             [(ngModel)]="selectedCompanies"
             [multiple]="asFilter"
             [closeOnSelect]="!asFilter"
             (change)="manageCompanyChange()"
  >
  </ng-select>
</div>
